import React, { ChangeEvent, SetStateAction, Dispatch } from 'react';
import { ChangePlanRequest } from '../types';
import { RadioFieldBox } from '@/components/RadioField';
import { DateFieldBox } from '@/components/DateField';

type ChangePlanFormProps = {
  label: string;
  plan?: string;
  price?: number;
  changePlanRequest: ChangePlanRequest;
  status?: string;
  setChangePlanRequest: Dispatch<SetStateAction<ChangePlanRequest>>;
  lensPrices: {
    both: {
      id: string;
      price: string;
    },
    oneSide: {
      id: string;
      price: string;
    }
  }
}

export const ChangePlanForm: React.FC<ChangePlanFormProps> = ({
  label,
  plan,
  price,
  changePlanRequest,
  setChangePlanRequest,
  lensPrices,
  status
}) => {
  const displayPlan = (plan: string, price: string): string => {
    if(plan === 'both') return `両眼プラン(${price}円/月)`
    if(plan === 'right') return `片眼プラン(右眼)(${price}円/月)`
    if(plan === 'left') return `片眼プラン(左眼)(${price}円/月)`
    return '';
  }

  const planOptions = [
    {
      checked: changePlanRequest.afterPlan === "both" || changePlanRequest.afterPlan === '',
      label: displayPlan("both", lensPrices.both.price),
      onChange: () => setChangePlanRequest({...changePlanRequest, afterPlan: "both", afterPrice: lensPrices.both.price, lensPriceId: lensPrices.both.id})
    },
    {
      checked:  changePlanRequest.afterPlan === "right",
      label: displayPlan("right", lensPrices.oneSide.price),
      onChange: () => setChangePlanRequest({...changePlanRequest, afterPlan: "right", afterPrice: lensPrices.oneSide.price, lensPriceId: lensPrices.oneSide.id})
    },
    {
      checked: changePlanRequest.afterPlan === "left",
      label: displayPlan("left", lensPrices.oneSide.price),
      onChange: () => setChangePlanRequest({...changePlanRequest, afterPlan: "left", afterPrice: lensPrices.oneSide.price, lensPriceId: lensPrices.oneSide.id})
    },
  ];

  return (
    <React.Fragment>
      <div className="contact-box__item">
        <label className="contact-box__ttl">
          <span>{label}</span>
        </label>
        <div className="contact-box__ct">
          <p className="contact-box__desc mbpc-5 mbsp-5">{displayPlan(plan ?? '', price?.toString() ?? '')}</p>
          {status !== 'before_confirmation' && 
            <label className="checkbox-item correct-box__form-check mb0">
              <input
                type="checkbox"
                checked={changePlanRequest.isChangePlan}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  if(e.target.checked) {
                    setChangePlanRequest({
                      changeMonth: "",
                      afterPlan: "both",
                      afterPrice: lensPrices.both.price,
                      lensPriceId: lensPrices.both.id,
                      isChangePlan: true
                    })
                  } else {
                    setChangePlanRequest({
                      changeMonth: "",
                      afterPlan: "",
                      afterPrice: "",
                      lensPriceId: "",
                      isChangePlan: false
                    })
                  }
                }}
                id="fruitCheckbox"
              />
              <span className="checkmark"></span>
              プラン変更
            </label>
          }
        </div>
      </div>
      {changePlanRequest.isChangePlan &&
        <>
          <RadioFieldBox
            label="変更プラン"
            list={planOptions}
          />
          <DateFieldBox
            type="month"
            label={"プラン変更月"}
            value={changePlanRequest.changeMonth}
            required={true}
            onChange={event => {
              setChangePlanRequest({...changePlanRequest, changeMonth: event.target.value})
            }}
          />
        </>
      }
    </React.Fragment>
  )
}